import { HUB_SLICE_TYPES } from 'dpl/prismic/utils/customPropTypes';
import ArticleGroup from 'dpl/prismic/hub/article_group/components/ArticleGroup';
import MagazineHeader from 'dpl/prismic/hub/magazine_header/components/MagazineHeader';
import MagazineFrontPage from 'dpl/prismic/hub/magazine_front_page/components/MagazineFrontPage';
import CustomLinks from 'dpl/prismic/custom_links/components/CustomLinks';

import MagazineAboutCallout from '../components/MagazineAboutCallout';
import NewsletterSignup from '../components/NewsletterSignup';
import Accreditation from '../components/Accreditation';
import ActionCallout from '../components/ActionCallout';
import FeaturedWebinars from '../components/FeaturedWebinars';
import CustomLinkInsert from '../components/CustomLinkInsert';
import FeaturedPodcasts from '../components/FeaturedPodcasts';
import ArticlePreviewsList from '../components/ArticlePreviewsList';
import PodcastHeader from '../components/PodcastHeader';

export default {
  [HUB_SLICE_TYPES.NEWSLETTER_SIGNUP]: NewsletterSignup,
  [HUB_SLICE_TYPES.MAGAZINE_ABOUT_CALLOUT]: MagazineAboutCallout,
  [HUB_SLICE_TYPES.ARTICLE_GROUP]: ArticleGroup,
  [HUB_SLICE_TYPES.ACCREDITATION]: Accreditation,
  [HUB_SLICE_TYPES.MAGAZINE_HEADER]: MagazineHeader,
  [HUB_SLICE_TYPES.ACTION_CALLOUT]: ActionCallout,
  [HUB_SLICE_TYPES.MAGAZINE_FRONT_PAGE]: MagazineFrontPage,
  [HUB_SLICE_TYPES.CUSTOM_LINKS]: CustomLinks,
  [HUB_SLICE_TYPES.FEATURED_WEBINARS]: FeaturedWebinars,
  [HUB_SLICE_TYPES.CUSTOM_LINK_INSERT]: CustomLinkInsert,
  [HUB_SLICE_TYPES.FEATURED_PODCASTS]: FeaturedPodcasts,
  [HUB_SLICE_TYPES.ARTICLE_PREVIEWS_LIST]: ArticlePreviewsList,
  [HUB_SLICE_TYPES.PODCAST_HEADER]: PodcastHeader
};
